$(document).ready(function(){
    var quantity = $("#quantity").val();

    $("#number-range-low").val(0);
    $("#number-range-high").val(quantity - 1);
    
    $('#add-item-to-cart').live('click', function(){
      quantity = $('#quantity').val();
      var low_range = $("#number-range-low").val();
      var high_range = $("#number-range-high").val();

      low_range = parseInt(low_range);
      high_range = parseInt(high_range);
      
      var total = high_range - low_range;
      console.log("total " + total);
      console.log("high " + high_range);
      console.log("low " + low_range);
      console.log("quantity " + quantity);
      if(high_range < low_range){
          alert("you must select a valid number range");
          event.preventDefault();     
      }
      if(total + 1 != quantity){
          alert("you must select a number range that equals the total order of " + quantity);
          event.preventDefault();
      }
                //        
      var site_name = $('#site-name').val();
      var facility_code = $('#facility-code').val();
      if(facility_code == null || typeof facility_code === 'undefined' || facility_code == ""){      
        if(site_name == null || typeof site_name === 'undefined' || site_name == "" ){
          alert("Please enter a site name");
          event.preventDefault();   
        }  
      }    
    });       
});